import { getCurrentInstance } from 'vue';

export function useI18n() {
  const { proxy } = getCurrentInstance();
  const i18n = proxy.$i18n;
  
  // Return the translation function and other i18n properties
  return {
    t: i18n.t.bind(i18n),
    tc: i18n.tc.bind(i18n),
    te: i18n.te.bind(i18n),
    d: i18n.d.bind(i18n),
    n: i18n.n.bind(i18n),
    locale: i18n.locale
  };
}
